/*
 * Copyright (c) 2021 SARL SIGMA POLYNESIA
 */

import { toUpper } from 'lodash'
import { useIntl } from 'react-intl'
import FormField, {
  FormTextFieldProps
} from '../../../../client/js/components/form/fields/FormField'

function LastNameField (props: FormTextFieldProps) {
  const { name = 'lastName', ...others } = props
  const intl = useIntl()
  return (
    <FormField
      // autoComplete="family-name"
      label={intl.formatMessage({
        id: 'lastName',
        defaultMessage: 'Nom de famille'
      })}
      name={name}
      parser={toUpper}
      {...others}
    />
  )
}

export default LastNameField
